import { select, t, Trans } from '@lingui/macro';
import { StoryQuestion, useStoryQuestion } from '@/components/microstory/question';
import { CenteredStoryText } from '@/components/microstory/text';
import { AnnotatedType } from '@/components/annotated-type';

export function ClimateActionChapter1() {
  const answers = [
    { id: 'yes', label: t({ id: 'climate-action.chapter-1.question.answer-1', message: 'Yes' }) },
    { id: 'no', label: t({ id: 'climate-action.chapter-1.question.answer-2', message: 'No' }) },
  ];

  const { selectedAnswer, handleAnswer } = useStoryQuestion<(typeof answers)[number]>();

  let response;
  if (selectedAnswer?.id) {
    response = t({
      id: 'climate-action.chapter-1.question.response',
      message: select(selectedAnswer.id, {
        yes: "You're with young people!",
        no: 'Young people overwhelmingly disagree!',
      }),
    });
  }

  return (
    <>
      <StoryQuestion
        question={t({
          id: 'climate-action.chapter-1.question.question',
          message: 'Do you think humans can reduce most of the effects of climate change?',
        })}
        answers={answers}
        onAnswer={handleAnswer}
        selectedAnswer={selectedAnswer}
        response={response}
      />

      <CenteredStoryText>
        <Trans id="climate-action.chapter-1.text-1">
          On average, an overwhelming 86% of young people believe humans can still act to reduce
          most of the devastating effects of climate change.{' '}
          <AnnotatedType>They have hope!</AnnotatedType>
        </Trans>
      </CenteredStoryText>
    </>
  );
}
